import { Button } from "web/components"

export default function DropDownActionButtons({
  handleClear,
  handleAdd,
  addDisabled = false,
  addLabel = "Apply Filter",
}) {
  const canAdd = typeof handleAdd === "function"
  return (
    <div className="ml-auto">
      <span className="mr-4">
        <Button variant="secondary_default" onClick={handleClear}>
          Clear Filter
        </Button>
      </span>
      {canAdd && (
        <span>
          <Button onClick={handleAdd} disabled={addDisabled}>
            <span className="min-w-3xs">{addLabel}</span>
          </Button>
        </span>
      )}
    </div>
  )
}
